/* abcoffee — Shopify Forms bridge (v3.2, 09 Sep 2026)
   The theme's own HTML forms stay exactly as designed; the Shopify Forms app
   is the lead store. Each page carries a Shopify Forms inline block (added in
   the theme editor). This script hides that block off-screen and, when a
   visitor submits the theme form, copies the values into the block's fields
   inside its shadow DOM (text, phone, number, dropdown, date), presses its
   Submit and waits for the Forms API answer. On success the theme's own
   success note is shown in place. Only if the block is missing, the API
   rejects the data after the built-in retries, or it times out, the theme
   form is submitted the normal way (Shopify contact form -> store email) so a
   lead is never dropped.

   v2: claims the submit event first (capture phase on window) so Shopify's
   storefront hCaptcha, which hijacks /contact forms and reloads the page,
   never runs during the bridged attempt - only on the fallback path.
   v3.2: fills every field the Forms definitions mark required - dropdowns are
   the app's custom listbox (opened with ArrowDown, option clicked), the event
   date goes into the app's MM/DD/YYYY control and also into the text (the
   Forms "Event date" was created as a Birthday field, which rejects dates
   that are not in the past; on that rejection the control is retried with a
   sentinel past date so the lead still lands, with the real date in the text), guest counts are
   reduced to a number, and Forms-required text fields that the theme leaves
   optional get "Not provided" instead of causing a rejection.
   Forms are recognised by the hidden contact[Form] value each one already
   sends; no section markup was changed. */
(function () {
  'use strict';

  var CONFIG = {
    'Help / Contact': {
      map: { 'contact[name]': 'first_name', 'contact[email]': 'email', 'contact[phone]': 'phone_number', 'contact[body]': 'custom#message' },
      required: ['custom#message'],
      success: 'Message received. We’ll get back to you soon.', tag: 'div'
    },
    'Careers application': {
      map: { 'contact[name]': 'first_name', 'contact[email]': 'email', 'contact[phone]': 'phone_number', 'contact[Role]': 'custom#role_youre_applying_for', 'contact[Link]': 'custom#portfolio_resume_link', 'contact[body]': 'custom#tell_us_about_yourself' },
      required: ['custom#role_youre_applying_for', 'custom#tell_us_about_yourself'],
      success: 'Got it - the people team will be in touch.', tag: 'p'
    },
    'Events and Collabs enquiry': {
      map: { 'contact[name]': 'first_name', 'contact[Company]': 'company_name', 'contact[email]': 'email', 'contact[phone]': 'phone_number', 'contact[Guests]': 'custom#number_of_guests', 'contact[City]': 'custom#location_venue_city', 'contact[body]': 'custom#any_special_requests' },
      choice: { 'contact[Event type]': 'custom#event_type' },
      date: { 'contact[Event date]': true },
      number: { 'contact[Guests]': true },
      prefix: { 'contact[Event type]': { into: 'custom#any_special_requests', label: 'Event type' }, 'contact[Event date]': { into: 'custom#any_special_requests', label: 'Event date' }, 'contact[Guests]': { into: 'custom#any_special_requests', label: 'Guests' } },
      required: ['company_name', 'custom#number_of_guests', 'custom#location_venue_city', 'custom#any_special_requests'],
      success: 'We like it already. The events team will reach out.', tag: 'p'
    },
    'Partnership enquiry (About page)': {
      map: { 'contact[name]': 'first_name', 'contact[email]': 'email', 'contact[phone]': 'phone_number', 'contact[Company]': 'custom#company_organisation_1', 'contact[body]': 'custom#tell_us_about_your_idea' },
      choice: { 'contact[Type]': 'custom#partnership_type' },
      prefix: { 'contact[Type]': { into: 'custom#tell_us_about_your_idea', label: 'Partnership type' } },
      required: ['custom#company_organisation_1', 'custom#tell_us_about_your_idea'],
      success: 'Got it. We brew fast - expect a reply within 24h.', tag: 'p'
    },
    'Gifting brief': {
      map: { 'contact[name]': 'first_name', 'contact[email]': 'email', 'contact[phone]': 'phone_number', 'contact[Company]': 'custom#company_organisation', 'contact[Quantity]': 'custom#approximate_quantity', 'contact[Cities]': 'custom#delivery_city_cities', 'contact[body]': 'custom#tell_us_about_your_requirement' },
      choice: { 'contact[Occasion]': 'custom#occasion' },
      date: { 'contact[Needed by]': true },
      prefix: { 'contact[Occasion]': { into: 'custom#tell_us_about_your_requirement', label: 'Occasion' }, 'contact[Needed by]': { into: 'custom#tell_us_about_your_requirement', label: 'Needed by' }, 'contact[Co-branding]': { into: 'custom#tell_us_about_your_requirement', label: 'Co-branding' } },
      required: ['custom#company_organisation', 'custom#approximate_quantity', 'custom#delivery_city_cities', 'custom#tell_us_about_your_requirement'],
      success: 'Perfect. Our gifting team will be in touch.', tag: 'p'
    }
  };
  var NOT_PROVIDED = 'Not provided';
  var TIMEOUT_MS = 25000;            /* normal wait for the Forms API answer */
  var CHALLENGE_TIMEOUT_MS = 180000; /* while an hCaptcha puzzle is on screen, let the visitor solve it */

  /* Hide every Shopify Forms app section without display:none, so the app
     still initialises and its invisible captcha can run. */
  var style = document.createElement('style');
  style.textContent = '.shopify-section.abf-hidden{position:absolute!important;left:-9999px!important;top:0!important;width:1px!important;height:1px!important;overflow:hidden!important;padding:0!important;margin:0!important;opacity:0!important;pointer-events:none!important}';
  document.head.appendChild(style);
  function hideEmbeds() {
    document.querySelectorAll('shopify-forms-embed, [data-form-root]').forEach(function (el) {
      var sec = el.closest('.shopify-section'); if (sec) sec.classList.add('abf-hidden');
    });
  }
  hideEmbeds();
  new MutationObserver(hideEmbeds).observe(document.documentElement, { childList: true, subtree: true });

  /* ---- observe the Forms API so the outcome is a fact, not a guess ---- */
  var lastSubmission = null;
  var SUBMIT_RE = /forms\.shopifyapps\.com\/api\/v\d+\/form_submission/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (SUBMIT_RE.test(url)) {
        p.then(function (r) {
          var rec = function (body) { lastSubmission = { ok: r.ok, status: r.status, body: String(body || '').slice(0, 600), at: Date.now() }; };
          try { r.clone().text().then(rec, function () { rec(''); }); } catch (e) { rec(''); }
        }, function (e) { lastSubmission = { ok: false, status: 0, body: String(e), at: Date.now() }; });
      }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (SUBMIT_RE.test(String(u))) {
      this.addEventListener('loadend', function () { lastSubmission = { ok: this.status >= 200 && this.status < 300, status: this.status, body: String(this.responseText || '').slice(0, 600), at: Date.now() }; });
    }
    return origOpen.apply(this, arguments);
  };

  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  function setNative(el, val) {
    var proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(el, val); else el.value = val;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    el.dispatchEvent(new Event('blur', { bubbles: true }));
  }
  function findField(sr, key) {
    return sr.querySelector('[id="' + key + '"]') || sr.querySelector('[name="' + key + '"]');
  }
  function dateInput(sr, label) {
    var labs = sr.querySelectorAll('label');
    for (var i = 0; i < labs.length; i++) {
      if (labs[i].textContent.trim().toUpperCase() !== label) continue;
      var byFor = labs[i].htmlFor ? sr.querySelector('[id="' + labs[i].htmlFor + '"]') : null;
      var wrap = labs[i].parentElement;
      return byFor || labs[i].querySelector('input') || (wrap && wrap.querySelector('input'));
    }
    return null;
  }
  function writeDate(sr, iso) {                      /* Forms date controls are three boxes: MM / DD / YYYY */
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/); if (!m) return false;
    var mm = dateInput(sr, 'MM'), dd = dateInput(sr, 'DD'), yy = dateInput(sr, 'YYYY');
    if (!mm || !dd || !yy) return false;
    setNative(mm, m[2]); setNative(dd, m[3]); setNative(yy, m[1]); return true;
  }
  /* The Forms "Event date" was created as a Birthday field, which rejects any date that is
     not safely in the past (today included). When that happens the control gets this
     sentinel so the lead still lands; the real date always travels in the text field. */
  var SAFE_PAST_DATE = '2000-01-01';
  function niceDate(iso) { var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/); return m ? m[3] + '/' + m[2] + '/' + m[1] : String(iso || ''); }
  /* Forms' phone field is a masked component that only accepts a full
     international number ("+919123456789" -> "+91 91234 56789"); bare
     national digits are discarded. Indian numbers are the default. */
  function e164Phone(v) {
    var raw = String(v || '').trim();
    var d = raw.replace(/\D/g, '');
    if (!d) return '';
    if (raw.charAt(0) === '+' && d.length > 10) return '+' + d;
    if (d.length === 12 && d.indexOf('91') === 0) return '+' + d;
    if (d.length === 11 && d.charAt(0) === '0') return '+91' + d.slice(1);
    if (d.length === 10) return '+91' + d;
    return '+' + d;
  }
  var norm = function (s) { return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim(); };
  /* The app's dropdown is a custom listbox: ArrowDown on its toggle opens it,
     clicking a [role=option] selects it. Falls back to "Other". */
  function chooseOption(sr, key, wanted) {
    return new Promise(function (resolve) {
      var toggle = sr.querySelector('button[aria-labelledby^="' + key + '-selector-label"]');
      var valueEl = sr.getElementById(key + '-selector-value');
      if (!toggle) { resolve(false); return; }
      var current = valueEl ? valueEl.textContent.trim() : '';
      if (current && norm(current) === norm(wanted)) { resolve(true); return; }
      var open = function () { if (toggle.getAttribute('aria-expanded') !== 'true') { toggle.focus(); toggle.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowDown', bubbles: true, composed: true })); } };
      var tries = 0;
      var step = function () {
        open();
        setTimeout(function () {
          var opts = Array.prototype.slice.call(sr.querySelectorAll('[id="' + key + '-selector-dropdown"] [role="option"]'));
          if (!opts.length) { if (++tries < 8) return step(); resolve(false); return; }
          var pick = opts.filter(function (o) { return norm(o.textContent) === norm(wanted); })[0]
            || opts.filter(function (o) { return norm(o.textContent).indexOf(norm(wanted)) === 0 || norm(wanted).indexOf(norm(o.textContent)) === 0; })[0]
            || opts.filter(function (o) { return norm(o.textContent) === 'other'; })[0]
            || opts[0];
          pick.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, composed: true }));
          pick.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, composed: true }));
          pick.click();
          setTimeout(function () {
            var v = valueEl ? valueEl.textContent.trim() : '';
            if (v) { resolve(true); return; }
            if (++tries < 8) return step();
            resolve(false);
          }, 250);
        }, 250);
      };
      step();
    });
  }
  function visibleText(root) {                          /* text of rendered nodes only */
    if (!root) return '';
    var out = '';
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var p = n.parentElement; if (!p || /^(STYLE|SCRIPT)$/.test(p.tagName)) return NodeFilter.FILTER_REJECT;
      return p.getClientRects().length ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
    while (walker.nextNode()) out += walker.currentNode.nodeValue + ' ';
    return out.replace(/\s+/g, ' ').trim();
  }
  function errorText(sr) {
    var els = sr.querySelectorAll('[role="alert"], output, [class*="error" i], [class*="invalid" i]');
    var t = '';
    for (var i = 0; i < els.length; i++) { var s = visibleText(els[i]); if (s.length > 2) t += s + ' '; }
    return t.trim();
  }
  function challengeOpen() {                            /* an hCaptcha puzzle the visitor can actually see */
    var fr = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < fr.length; i++) {
      var el = fr[i], r = el.getBoundingClientRect();
      if (r.width < 150 || r.height < 150) continue;
      if (r.bottom <= 0 || r.right <= 0 || r.top >= window.innerHeight || r.left >= window.innerWidth) continue;
      var ok = true;
      for (var n = el; n && n !== document.body; n = n.parentElement) { var cs = getComputedStyle(n); if (cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity === 0) { ok = false; break; } }
      if (ok) return true;
    }
    return false;
  }

  function attach(form) {
    var idEl = form.querySelector('input[name="contact[Form]"]');
    var cfg = idEl && CONFIG[idEl.value];
    if (!cfg || !Object.keys(cfg.map).length) return;
    form.__abf = { cfg: cfg, idEl: idEl, busy: false };
  }

  function run(form, ev) {
    var st = form.__abf, cfg = st.cfg, idEl = st.idEl;
    var embed = document.querySelector('shopify-forms-embed');
    var sr = embed && embed.shadowRoot;
    var appForm = sr && sr.querySelector('form');
    if (!appForm || st.busy) return false;                       /* no app block on this page -> native */
    ev.preventDefault(); ev.stopImmediatePropagation();          /* keep Shopify's captcha out of this attempt */
    st.busy = true;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }

    var values = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name === 'contact[Form]') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      values[el.name] = el.value;
    });
    var telKey = null, bodyKey = null;
    Object.keys(cfg.map).forEach(function (k) { var f = findField(sr, cfg.map[k]); if (f && f.type === 'tel') telKey = k; if (/\[body\]$/.test(k)) bodyKey = k; });
    var dateKeys = Object.keys(cfg.date || {});

    var finish = function (ok) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); }
      st.busy = false;
      if (!ok) return;
      var note = form.querySelector('[data-forms-success]');
      if (!note) {
        note = document.createElement(cfg.tag || 'p');
        note.className = 'form-note'; note.setAttribute('data-forms-success', ''); note.setAttribute('role', 'status');
        note.textContent = cfg.success;
        idEl.insertAdjacentElement('afterend', note);            /* same spot the native note renders */
      }
      note.style.display = 'block';
      form.reset();
      try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    };
    var fallback = function () {
      finish(false);
      form.dataset.abfFallback = '1';
      /* A real submit event: Shopify's captcha handler (bound to this form) now
         runs as if the bridge did not exist, gets its token and posts natively. */
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
    };

    /* opts: { phoneInBody, dateToday } - the two retry variants */
    var attempt = function (opts) {
      var prefixes = {};
      var addPrefix = function (into, label, val) { if (!val) return; prefixes[into] = (prefixes[into] || '') + label + ': ' + val + '\n'; };
      Object.keys(cfg.prefix || {}).forEach(function (k) {
        var p = cfg.prefix[k]; var v = values[k];
        if (cfg.date && cfg.date[k]) v = niceDate(v);
        addPrefix(p.into, p.label, v);
      });
      if (opts.phoneInBody && telKey && bodyKey) addPrefix(cfg.map[bodyKey], 'Phone', String(values[telKey] || '').trim());

      var wrote = 0;
      Object.keys(cfg.map).forEach(function (k) {
        var target = findField(sr, cfg.map[k]); if (!target) return;
        var v = String(values[k] || '');
        if (target.type === 'tel') v = opts.phoneInBody ? '' : e164Phone(v);
        else if (cfg.number && cfg.number[k]) { var n = v.match(/\d[\d,]*/); v = n ? n[0].replace(/,/g, '') : ''; }
        if (prefixes[cfg.map[k]]) v = prefixes[cfg.map[k]] + v;
        if (!v.trim() && (cfg.required || []).indexOf(cfg.map[k]) !== -1) v = (target.type === 'number') ? '0' : NOT_PROVIDED;
        setNative(target, v); wrote++;
      });
      Object.keys(prefixes).forEach(function (into) {
        var mapped = Object.keys(cfg.map).some(function (k) { return cfg.map[k] === into; });
        if (mapped) return;
        var t = findField(sr, into); if (t) { setNative(t, prefixes[into].trim()); wrote++; }
      });
      if (dateKeys.length) {
        var iso = values[dateKeys[0]];
        if (opts.dateToday || !iso) iso = SAFE_PAST_DATE;
        writeDate(sr, iso);
      }
      if (!wrote) { fallback(); return; }

      var choicePromises = Object.keys(cfg.choice || {}).map(function (k) { return chooseOption(sr, cfg.choice[k], values[k] || 'Other'); });
      Promise.all(choicePromises).then(function () { return wait(150); }).then(function () {
        var appSubmit = sr.querySelector('button[type="submit"]');
        if (!appSubmit) { fallback(); return; }
        var started = Date.now(), pressed = false, lastAt = lastSubmission ? lastSubmission.at : 0;
        var timer = setInterval(function () {
          var now = Date.now();
          if (!pressed) {                                        /* press Submit as soon as the app is idle */
            if (!appSubmit.disabled || now - started > 6000) {
              /* The app's phone field quietly drops a number it will not take (a foreign
                 one, for instance). If that happened, keep the number in the message. */
              if (telKey && !opts.phoneInBody && bodyKey) {
                var telField = findField(sr, cfg.map[telKey]), rawPhone = String(values[telKey] || '').trim();
                if (telField && rawPhone.replace(/\D/g, '').length >= 5 && String(telField.value || '').replace(/\D/g, '').length < 5) {
                  var bodyField = findField(sr, cfg.map[bodyKey]);
                  if (bodyField) setNative(bodyField, 'Phone: ' + rawPhone + '\n' + bodyField.value);
                }
              }
              pressed = true; try { appSubmit.click(); } catch (e) {}
            }
            return;
          }
          var res = lastSubmission && lastSubmission.at > lastAt ? lastSubmission : null;
          if (res) {
            clearInterval(timer);
            if (res.ok) { finish(true); return; }
            if (!opts.phoneInBody && telKey && /phone/i.test(res.body)) { attempt({ phoneInBody: true, dateToday: opts.dateToday }); return; }
            if (!opts.dateToday && dateKeys.length && /date|birthday|future/i.test(res.body)) { attempt({ phoneInBody: opts.phoneInBody, dateToday: true }); return; }
            fallback(); return;
          }
          var stillForm = sr.querySelector('form');
          var shown = visibleText(sr);
          if (!stillForm || /thank you|has been submitted|submitted successfully/i.test(shown)) { clearInterval(timer); finish(true); return; }
          var err = now - started > 2500 ? errorText(sr) : '';
          if (err) {
            clearInterval(timer);
            if (!opts.dateToday && dateKeys.length && /date|birthday|future/i.test(err)) { attempt({ phoneInBody: opts.phoneInBody, dateToday: true }); return; }
            if (!opts.phoneInBody && telKey && /phone|number is invalid/i.test(err)) { attempt({ phoneInBody: true, dateToday: opts.dateToday }); return; }
            fallback(); return;
          }
          var limit = challengeOpen() ? CHALLENGE_TIMEOUT_MS : TIMEOUT_MS;
          if (now - started > limit) { clearInterval(timer); fallback(); }
        }, 200);
      });
    };
    attempt({ phoneInBody: false, dateToday: false });
    return true;
  }

  /* Capture phase on window: runs before Shopify's document-level captcha
     bootstrap and before the hCaptcha handler bound to the form itself. */
  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form instanceof HTMLFormElement) || !form.__abf) return;
    if (form.dataset.abfFallback === '1') return;                /* second pass = native submit, untouched */
    run(form, ev);
  }, true);

  function init() { document.querySelectorAll('form[action*="/contact"]').forEach(attach); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
